import { push, goBack } from 'react-router-redux';

export * from './user';
export * from './employees';
export * from './workrooms';
export * from './tasks';
export * from './stores';
export * from './dropdown_lists';
export * from './estimators';
export * from './installers';
export * from './iqms';
export * from './surface_types';
export * from './phases';
export * from './phase';
export * from './document_uploads';
export * from './pay_rates';
export * from './pay_rates_uploads';
export * from './schedule';
export * from './saved_filters';
export * from './assigned_filters';
export * from './scraper';
export * from './cocs';
export * from './lrrps';
export * from './ifi_lrrps';
export * from './walkthroughs';
export * from './settings';
export * from './repair_inspection_report';
export * from './crew_inspection';
export * from './job_paperwork_templates';
export * from './refigure_form';
export * from './phase_items';
export * from './ptos';
export * from './traveling_work_dates';
export * from './reports';
export * from './survey';
export * from './line_items';
export * from './uploads';
export * from './ims_actions';
export * from './default_installer_pay';
export * from './projects';
export * from './quick_schedule';

export function navigate(url) {
  return push(url);
}

export function navigateBack() {
  return goBack();
}

export function clearValidationErrors(entity, errors = {}) {
  return (dispatch) => {
    dispatch({
      type: `${entity}_RESOURCE_CLEAR_VALIDATION`,
      payload: errors,
    });
  };
}

export function listOfRequests(list) {
  return () => Promise.all(list);
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/index.js